import type { FeatureContext } from '../../types';
import './overview.css';

export function OverviewFeature({
  apiBaseUrl,
  fallbackBaseUrl,
  shouldExplainFallback
}: FeatureContext) {
  return (
    <section className="page-section overview">
      <h1>Project Hermes</h1>
      <p>Frontend powered by Vite + React, served from Azure Static Web Apps.</p>
      <p>
        API base URL: <code>{apiBaseUrl}</code>
      </p>
      {shouldExplainFallback && (
        <p>
          If the browser blocks requests to the API base above (for example, due to CORS), Project Hermes automatically retries
          the call via the Static Web Apps proxy at <code>{fallbackBaseUrl}</code>.
        </p>
      )}
    </section>
  );
}
